import Loadable from "react-loadable";

const LazyJobPromise = Loadable({
  loader: () => import(/* webpackChunkName: 'job-promise' */ "./index"),
  loading: () => 'loading...'
});

export default LazyJobPromise;
